// audio.js — one shared, user-gesture-unlocked AudioContext used by the
// notification chime. Modern browsers (esp. iOS Safari + Android Chrome)
// suspend any AudioContext created without a preceding user gesture, so
// we install one-shot listeners on the first pointer/keyboard event and
// resume the context there. After that, playDing() can fire silently
// from a background poll without being autoplay-blocked.

let ctx = null;
let unlocked = false;

function getContext() {
    if (ctx) return ctx;
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return null;
    ctx = new AudioCtx();
    return ctx;
}

function unlock() {
    if (unlocked) return;
    const c = getContext();
    if (!c) return;
    // Play a truly silent buffer to satisfy autoplay rules
    try {
        const buf = c.createBuffer(1, 1, 22050);
        const src = c.createBufferSource();
        src.buffer = buf;
        src.connect(c.destination);
        src.start(0);
    } catch (_e) { /* ignore */ }
    if (c.state === "suspended") c.resume().catch(() => {});
    unlocked = true;
}

// Attach unlock listeners exactly once, module-scoped.
if (typeof window !== "undefined") {
    const events = ["click", "touchstart", "keydown", "pointerdown"];
    const onFirstGesture = () => {
        unlock();
        events.forEach((ev) => window.removeEventListener(ev, onFirstGesture));
    };
    events.forEach((ev) => window.addEventListener(ev, onFirstGesture, { once: false, passive: true }));
}

export function playDing() {
    const c = getContext();
    if (!c) return;
    // If still suspended (no gesture yet on this page), try resuming — will
    // succeed silently if the user has ever clicked; otherwise stays silent.
    if (c.state === "suspended") c.resume().catch(() => {});

    const now = c.currentTime;
    const play = (freq, delay, dur = 0.15) => {
        try {
            const osc = c.createOscillator();
            const gain = c.createGain();
            osc.type = "sine";
            osc.frequency.value = freq;
            gain.gain.setValueAtTime(0.0001, now + delay);
            gain.gain.exponentialRampToValueAtTime(0.18, now + delay + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, now + delay + dur);
            osc.connect(gain).connect(c.destination);
            osc.start(now + delay);
            osc.stop(now + delay + dur + 0.02);
        } catch (_e) { /* ignore */ }
    };
    play(880, 0);
    play(1174.66, 0.11);
}

export function isAudioUnlocked() {
    return unlocked && ctx && ctx.state === "running";
}
